import { getAccessToken } from "./auth";
import createRequest from "./createRequest";
import { getHttpAgent } from "./getHttpAgent";
import { gaodingUmsHost } from "./host";

// yapi、dev、fat、stage、production
const API = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "https://gd-dev.huaban.com/api",
  fat: "https://gd-fat.huaban.com/api",
  stage: "https://gd-stage.huaban.com/api",
  prod: "https://gd.huaban.com/api",
};

const ServerApi = {
  yapi: "https://yapi.gaoding.com/mock/1536",
  dev: "http://dev.gaoding.com/api",
  fat: "http://fat.gaoding.com/api",
  stage: "http://stage.gaoding.com/api",
  prod: "http://gaoding.com/api",
};

const CHANNEL_ID_MAP = {
  yapi: 281,
  dev: 281,
  fat: 240,
  stage: 289,
  prod: 289,
};

const BUSSINESS_ID_MAP = {
  yapi: 33,
  dev: 33,
  fat: 61,
  stage: 57,
  prod: 57,
};

export const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

export const BaseURL =
  typeof window === "undefined" ? ServerApi[env] : API[env];
export const REQUEST_MESSAGE_KEY = "REQUEST_MESSAGE_KEY";

const axios = createRequest({
  BaseURL,
});

const umsAxios = createRequest({
  BaseURL: `${
    typeof window === "undefined" ? "https" : location.protocol
  }//${gaodingUmsHost}`,
});

/**
 * 公共请求方法
 * @param {{
 *  url: string,
 *  params?: Object,
 *  query?: Object,
 *  ignoreMessage?: boolean,
 *  ignoreError?: boolean,
 *  serverSideHttps?: boolean,
 *  cache?: boolean | {time: number}
 *  ums?: boolean
 * } & import('axios').AxiosRequestConfig} param
 * @returns {Promise<any>}
 */
const request = async (props) => {
  const {
    url = "/",
    params, // url匹配参数
    query, // 查询参数
    headers = {},
    ignoreMessage,
    ignoreError,
    serverSideHttps,
    ums,
    ...opts
  } = props;

  const accessToken = await getAccessToken(headers?.cookie);

  const req = ums ? umsAxios : axios;

  if (props.retryTimes > 3) {
    return Promise.reject({
      code: "REQUEST_RETRY_TIMES_EXCEEDED",
      message: "请求重试次数超过3次",
    });
  }

  try {
    return await req({
      url,
      params: query,
      options: {
        params,
        ignoreMessage,
        ignoreError,
        accessToken,
        request: request,
        times: 0,
      },
      timeout: 10000,
      headers: {
        "X-Business-Id": BUSSINESS_ID_MAP[env],
        "X-Channel-Id": CHANNEL_ID_MAP[env],
        ...(accessToken
          ? {
              authorization: `Bearer ${accessToken}`,
            }
          : null),
        ...headers,
      },
      ...(typeof window === "undefined"
        ? {
            httpAgent: getHttpAgent(),
          }
        : null),
      ...opts,
    });
  } catch (error) {}
};

if (typeof window !== "undefined") {
  window.gdRequest = request;
}

export default request;
